import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import loading from '../../../../images/loading.gif';
import { EkioskConfigMessageKeys, IKIOSKModel, KioskMessage } from '../../../../models/kioskModel2';
import { Ilanguages } from '../../../../models/utilitiesModel';

const PageLoading: React.FC = () => {
    const loadings: boolean = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.loading || false);
    const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    const fatchingMes: KioskMessage = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.kioskConfigdata?.kioskMessage?.find((x) => x?.msgKey === EkioskConfigMessageKeys.FATCHINGMES) || undefined);
    const { t } = useTranslation("translations");
    return (
        <>
            {loadings && <div className='d-flex flex-column align-items-center processing_msg'>
                <span>{fatchingMes ? (language === Ilanguages.ENG ? fatchingMes?.msgValueEn : fatchingMes?.msgValueAr) : t("kiosktranslation.loadMes" + language)}</span>
                <img src={loading} alt="loading" width="140" />
            </div>}
        </>)
}

export default React.memo(PageLoading);